import React, { FC, useState } from 'react';
import { Stack, Typography } from '@mui/material';
import styles from './SizeMatchComponent.module.scss';
import SizeMatchItemComponent from '../SizeMatchItemComponent/SizeMatchItemComponent';
import { SizeMatchRecommendation } from '../../../services/DataFormatService';
import SizeMatchFilter, { Filters } from '../SizeMatchFilter/SizeMatchFilter';

interface SizeMatchComponentProps {
    sizeMatchRecommendations: SizeMatchRecommendation[];
}

const SizeMatchComponent: FC<SizeMatchComponentProps> = (props) => {
    const { sizeMatchRecommendations } = props;
    const [selectedFilters, setSelectedFilters] = useState<Filters | null>(null);

    const garmentTypes = sizeMatchRecommendations
        .map((recommendation) => recommendation.garmentType)
        .filter((value, index, self) => self.indexOf(value) === index);

    const garmentFilteredRecommendations = sizeMatchRecommendations
        .filter((recommendation) => !selectedFilters?.garmentType
            || recommendation.garmentType === selectedFilters.garmentType);

    const garmentAndFitfilteredRecommendations = garmentFilteredRecommendations.filter((recommendation) => !selectedFilters?.fits?.length
        || selectedFilters.fits.includes(recommendation.gender));

    const fitsInSelection = [...new Set(
        garmentFilteredRecommendations.map((rec) => rec.gender),
    )].sort((a, b) => a.localeCompare(b));

    return (
        <div className={styles.SizeMatchComponent} data-testid="SizeMatchComponent">
            <Typography
                variant="h1"
                sx={{ pb: 4 }}
            >
                SizeMatch
            </Typography>
            <Stack spacing={1}>
                <SizeMatchFilter
                    garmentTypes={garmentTypes}
                    fits={fitsInSelection}
                    setSelectedFilters={setSelectedFilters}
                />
                {garmentAndFitfilteredRecommendations.map((recommendation) => (
                    <SizeMatchItemComponent
                        key={`sizeMatchRecommendation-${recommendation.productCode}-${recommendation.gender}`}
                        sizeMatchRecommendation={recommendation}
                    />
                ), [])}
            </Stack>
        </div>
    );
};

export default SizeMatchComponent;
